"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useMultipleDocuments = exports.retrieveDocumentsFromPreload = exports.retrieveDocumentsFromCache = exports.useSingleDocument = void 0;
var debug_1 = __importDefault(require("debug"));
var react_1 = __importDefault(require("react"));
var multi_document_aggregator_1 = require("./src/multi-document-aggregator");
var single_document_aggregator_1 = require("./src/single-document-aggregator");
debug_1["default"].disable();
function useSingleDocument(client, options) {
    var initialAggregator = react_1["default"].useMemo(function () { return new single_document_aggregator_1.SingleDocumentAggregator(client, options); }, []);
    var _a = react_1["default"].useState(initialAggregator), aggregator = _a[0], setAggregator = _a[1];
    var _b = react_1["default"].useState(aggregator._current), data = _b[0], setData = _b[1];
    // @ts-expect-error ---
    var mutation = client._useReactiveMutation(aggregator._mutation);
    var paramsHashRef = react_1["default"].useRef(JSON.stringify(options.query.params));
    react_1["default"].useEffect(function () {
        var paramsHash = JSON.stringify(options.query.params);
        if (options.disabled !== true && paramsHashRef.current !== paramsHash) {
            paramsHashRef.current = paramsHash;
            aggregator.destroy();
            setAggregator(new single_document_aggregator_1.SingleDocumentAggregator(client, options));
        }
    }, [options, aggregator]);
    react_1["default"].useEffect(function () {
        var stop = aggregator.listen(function (nd) {
            setData(nd);
        }).stop;
        return stop;
    }, [aggregator, setData]);
    return {
        data: data,
        queryLoading: mutation.isLoading
    };
}
exports.useSingleDocument = useSingleDocument;
function retrieveDocumentsFromCache(forKey, cache) {
    return __awaiter(this, void 0, void 0, function () {
        var result, documentPromises, documents;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, cache.get("".concat(forKey, "/_list"))];
                case 1:
                    result = _a.sent();
                    if (!(result != null)) return [3 /*break*/, 3];
                    documentPromises = result.map(function (itemKey) { return cache.get("".concat(forKey, "/").concat(itemKey)); });
                    return [4 /*yield*/, Promise.all(documentPromises)];
                case 2:
                    documents = (_a.sent()).filter(function (d) { return d != null; });
                    return [2 /*return*/, documents];
                case 3: return [2 /*return*/, []];
            }
        });
    });
}
exports.retrieveDocumentsFromCache = retrieveDocumentsFromCache;
function retrieveDocumentsFromPreload(forKey, cache) {
    var result = cache.getPreloaded("".concat(forKey, "/_list"));
    if (result != null) {
        var documents = result.map(function (itemKey) { return cache.getPreloaded("".concat(forKey, "/").concat(itemKey)); }).filter(function (d) { return d != null; });
        return documents;
    }
    return [];
}
exports.retrieveDocumentsFromPreload = retrieveDocumentsFromPreload;
function useMultipleDocuments(client, options) {
    var _a;
    var initialAggregator = react_1["default"].useMemo(function () {
        return new multi_document_aggregator_1.MultiDocumentAggregator(client, options);
    }, []);
    var _b = react_1["default"].useState(initialAggregator), aggregator = _b[0], setAggregator = _b[1];
    var _c = react_1["default"].useState(aggregator._current), data = _c[0], setData = _c[1];
    // @ts-expect-error ---
    var mutation = client._useReactiveMutation(aggregator._mutation);
    var paramsHashRef = react_1["default"].useRef(JSON.stringify((_a = options.query.deps) !== null && _a !== void 0 ? _a : options.key));
    react_1["default"].useEffect(function () {
        var _a;
        var paramsHash = JSON.stringify((_a = options.query.deps) !== null && _a !== void 0 ? _a : options.key);
        if (options.disabled !== true && paramsHashRef.current !== paramsHash) {
            if (options.resetWhenAggregatorChanges === true) {
                setData([]);
            }
            paramsHashRef.current = paramsHash;
            aggregator.destroy();
            setAggregator(new multi_document_aggregator_1.MultiDocumentAggregator(client, options));
        }
    }, [options, aggregator]);
    react_1["default"].useEffect(function () {
        setData(aggregator._current);
        var stop = aggregator.listen(function (nd) {
            setData(nd);
        }).stop;
        return stop;
    }, [aggregator, setData]);
    return {
        data: data,
        queryLoading: mutation.isLoading,
        refreshQuery: aggregator.refresh,
        _ingest: aggregator._ingest
    };
}
exports.useMultipleDocuments = useMultipleDocuments;
